import { Box, Grid, Hidden, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'services/localization';

export const PaymentMethodHeaderRow = () => {
	const { t } = useTranslation();
	return (
		<Grid container alignItems="flex-end" spacing={1}>
			<Grid item xs>
				<Typography variant="body1" color="textSecondary">
					<Box component="span" fontWeight={500}>
						{t('shop.paymentMethods', 'Payment methods')}
					</Box>
				</Typography>
			</Grid>
			<Hidden smDown>
				<Grid item xs="auto">
					<Typography variant="body1" color="textSecondary">
						<Box component="span" fontWeight={500}>
							{t('shop.pricingPerTransaction', 'Price / transaction')}
						</Box>
					</Typography>
				</Grid>
			</Hidden>
		</Grid>
	);
};
